<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="6" justify="center" class="loading-wrapper">
        <v-progress-circular size="96" width="8" indeterminate />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="6">
        <v-fade-transition>
          <v-alert v-if="message" type="info" color="info">
            {{ message }}
          </v-alert>
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      message: null,
    };
  },
  mounted() {
    setTimeout(() => {
      this.message = 'When trying to view a lot of data it may take a while to load';
    }, 7000);
  },
};
</script>

<style lang="scss">
.v-progress-circular {
  margin-top: 32px;
}
.loading-wrapper {
  text-align: center;
}
</style>
